<template>
  <el-row :getter="20">
    <el-col :span="6">
      <el-tree
        :data="govTree"
        :props="govTreeProps"
      ></el-tree>
    </el-col>
    <el-col :span="18">
      <div class="tabel-bar">
        <div class="tabel-bar-left">
          <el-button type="primary" size="medium" @click="userPopup()"
            >新增用户</el-button
          >
          <el-button size="medium">分配用户</el-button>
        </div>
        <div class="tabel-bar-right">
          <el-input
            placeholder="请输入内容"
            prefix-icon="el-icon-search"
            size="medium"
          ></el-input>
          <el-tooltip effect="dark" content="刷新列表" placement="bottom">
            <span class="el-icon-refresh icon-hover refresh-btn"></span>
          </el-tooltip>
          <!-- <el-tooltip effect="dark" content="筛选列表" placement="bottom">
            <el-popover
              placement="bottom-end"
              width="120"
              trigger="click"
            >
              <el-checkbox-group v-model="checkList">
                <el-checkbox label="用户编号"></el-checkbox>
                <el-checkbox label="用户名"></el-checkbox>
                <el-checkbox label="姓名"></el-checkbox>
                <el-checkbox label="状态"></el-checkbox>
                <el-checkbox label="用户"></el-checkbox>
                <el-checkbox label="所属组织机构"></el-checkbox>
              </el-checkbox-group>
                <i
                  slot="reference"
                  class="d-block iconfont icon-liebiao is-rotate"
                ></i>
            </el-popover>
          </el-tooltip> -->
        </div>
      </div>
      <el-table v-loading="loading" :data="tableData" @selection-change="handleSelectionChange">
        <el-table-column
          type="selection"
          width="55"
        >
        </el-table-column>
        <el-table-column
          property="jigou"
          label="所属机构"
        ></el-table-column>
        <el-table-column
          property="loginName"
          label="登录名"
        ></el-table-column>
        <el-table-column
          property="name"
          label="姓名"
        ></el-table-column>
        <el-table-column
          property="static"
          label="状态"
        ></el-table-column>
        <el-table-column
          property="user"
          label="用户"
        ></el-table-column>
        <el-table-column
          property="regTime"
          label="注册时间"
        ></el-table-column>
        <el-table-column
          property="caozuo"
          width="160"
          label="操作"
        >
          <template slot-scope="scope">
            <el-button type="text" @click="userPopup(scope.row.id)"
              >编辑</el-button
            >
            <el-button type="text" @click="userDel(scope.row.id)"
              >删除</el-button
            >
          </template>
          <el-button type="text">分配用户</el-button>
        </el-table-column>
      </el-table>
      <pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-size="size"
        :total="total"
      >
      </pagination>
    </el-col>
    <!-- 用户表单 -->
    <el-dialog  :close-on-click-modal="false" :append-to-body="true" :title="title" :visible.sync="userFormVisible" center>
      <el-form
        :model="userForm"
        size="medium"
        :rules="userFormRules"
        ref="refuserForm"
        label-width="100px"
      >
        <el-form-item label="用户名称：" prop="name">
          <el-input
            v-model="userForm.name"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="medium" :disabled="isDisabled" @click="debounceSubmit">确 定</el-button>
        <el-button size="medium" @click="userFormVisible = false"
          >取 消</el-button
        >
      </div>
    </el-dialog>
  </el-row>
</template>

<script>
import { debounce } from 'throttle-debounce'
import {
  getUserList,
  putUserAdd,
  getUserDetail,
  postUserEdit,
  deleteUserDel
} from '@/api/user'

const createFormVals = () => ({
  name: ''
})

export default {
  data() {
    return {
      currentID: null,
      isDisabled: false,
      total: 0,
      size: 10,
      page: 1,
      keywords: '',
      userFormVisible: false,
      checkList: [],
      govTreeProps: {
        children: 'children',
        label: 'label'
      },
      govTree: [
        {
          label: '沂水县农机局',
          children: [
            {
              label: '镇级别',
              children: [
                {
                  label: '村级别'
                }
              ]
            }
          ]
        },
        {
          label: '沂水县农机局2',
          children: [
            {
              label: '镇级别2-1',
              children: [
                {
                  label: '村级别2-1-1'
                }
              ]
            },
            {
              label: '镇级别22-2',
              children: [
                {
                  label: '村级别2-2-1'
                }
              ]
            }
          ]
        },
        {
          label: '沂水县农机局 3',
          children: [
            {
              label: '二级 3-1',
              children: [
                {
                  label: '三级 3-1-1'
                }
              ]
            },
            {
              label: '二级 3-2',
              children: [
                {
                  label: '三级 3-2-1'
                }
              ]
            }
          ]
        }
      ],
      tableData: [],
      userForm: createFormVals(),
      loading: true,
      selectionID: [],
      userFormRules: {}
    }
  },
  computed: {
    title() {
      return this.currentID ? '编辑用户' : '新增用户'
    }
  },
  created() {
    this.debounceSubmit = debounce(300, this.userSubmit)
    this.debounceRefresh = debounce(300, this.refresh)
  },
  methods: {
    handleSelectionChange(selection) {
      this.selectionID = selection.map(_ => _.id)
    },
    // 分页
    handleSizeChange(val) {
      this.size = val
      this.getUserListData()
    },
    handleCurrentChange(val) {
      this.page = val
      this.getUserListData()
    },
    // 删除用户
    userDel(id) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteUserDel({
            id: id
          }).then(res => {
            if (res.status === 1) {
              this.$message.success('删除用户成功')
              this.getUserListData()
            } else {
              this.$message.error(res.msg)
              return false
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 新增/编辑用户
    userSubmit() {
      this.$refs.refuserForm.validate(valid => {
        if (!valid) return false
        const changeRole = this.currentID ? postUserEdit : putUserAdd
        changeRole({
          name: this.userForm.name,
          id: this.currentID || undefined
        }).then(res => {
          if (res.status === 1) {
            this.currentID ? this.$message.success('编辑用户成功') : this.$message.success('新增用户成功')
            this.userFormVisible = false
            this.getUserListData()
          } else {
            this.$message.error(res.msg)
            return false
          }
        })
      })
    },
    // 打开用户表单
    rolePopup(id) {
      const isAdd = !id
      this.userFormVisible = true

      if (isAdd) {
        this.$set(this, 'userForm', createFormVals())
        this.currentID = null
      } else {
        this.isDisabled = true
        this.currentID = id
        getUserDetail({ id }).then(res => {
          if (res.status === 1) {
            this.userForm.name = res.data.name
            this.isDisabled = false
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    // 检索
    search() {
      this.getUserListData()
    },
    // 刷新数据表格
    refresh() {
      this.getUserListData()
      this.$message.success('数据刷新成功')
    },
    // 获取用户列表
    getUserListData() {
      this.loading = true
      getUserList({
        page: this.page,
        size: this.size,
        keywords: this.keywords
      }).then(res => {
        if (res.status === 1) {
          this.total = res.data.total
          this.tableData = res.data.rows
        } else {
          this.$message.error(res.msg)
        }
        this.loading = false
      })
    }
  },
  mounted() {
    this.getUserListData()
  }
}
</script>
